export enum UseCases {
  None = 0,
  Accumate = 1,
  Research = 2,
  Layer = 3,
  Monitoring = 4,
  Lead = 5,
  Others = 6
}
